import type { IconProps as Props } from './types';

export const IconUpDownSwitch = ({
  className = null,
  width = '1em',
  height = '1em',
  fill = 'none',
  stroke = 'var(--text-neutral-faded)',
  ...rest
}: Props) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="Up Down (Switch)">
        <path
          id="Path"
          d="M13.3334 4.66667L10.6667 7.33333M10.6667 11.3333H2.66669H10.6667ZM2.66669 11.3333L5.33335 14L2.66669 11.3333ZM2.66669 11.3333L5.33335 8.66667L2.66669 11.3333ZM5.33335 4.66667H13.3334H5.33335ZM13.3334 4.66667L10.6667 2L13.3334 4.66667Z"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
